import { WobbleUpdater } from "./WobbleUpdater";
export async function loadWobbleUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("wobble", (container) => new WobbleUpdater(container), refresh);
}
